export default __webpack_public_path__ + "a45563d4046c99604355d7ae25f82178.webp";